<template>
  <div>
    <div class="opo02">
      <span class="opo03" @click="back">标品库列表 ></span>
      <span class="opo04"> 待审核列表</span>
    </div>
    <div class="opo01">
      <div class="djt30">
        <div class="djt31">
          <input v-model="searchs" type="text" placeholder="输入名称进行搜索" placeholder-class="djt32" class="djt33">
          <img @click="seas" src="@/assets/images/sea01.png" alt="" class="djt34">
        </div>
      </div>
<!--      <div style="width: 50%;display: flex;justify-content: flex-end">-->
<!--        <div class="djt02" style="margin-right: 20px" @click="xjsp">-->
<!--          <img src="@/assets/images/qw2.png" class="djt03" alt="">-->
<!--          <p class="djt04">新建商品</p>-->
<!--        </div>-->
<!--        <div class="djt02" @click="">-->
<!--          <img src="@/assets/images/qw1.png" class="djt03" alt="">-->
<!--          <p class="djt04">商品审核</p>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="djt05">
      <div class="djt06">
        <div class="djt26">图片</div>
        <div class="djt26">名称</div>
        <div class="djt26">编码</div>
        <div class="djt26">规格</div>
        <div class="djt26">状态</div>
      </div>
      <el-skeleton animated :loading="loading" :count="6">
        <template slot="template">
          <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
        </template>
        <template>
          <div class="djt09" v-for="(item,index) in data.dataList" :key="'lis'+index">
            <div class="djt27" style="display: flex;justify-content: center;">
              <img :src="item.url" alt="" class="bpk01">
            </div>
            <div class="djt27" :title="item.name">{{item.name}}</div>
            <div class="djt27" :title="item.code">{{item.code}}</div>
            <div class="djt27" :title="item.specs">{{item.specs}}</div>
            <div class="djt28">
              <img src="@/assets/images/qw4.png" title="通过审核" class="djy16" alt="" @click="tgsh(item)">
              <img src="@/assets/images/qw5.png" title="拒绝通过" class="djy16" alt="" @click="jjtg(item,index)" style="margin-left: 20px">
            </div>
          </div>
        </template>
      </el-skeleton>
      <div class="djt09" style="border-bottom: none;margin-top: 5px;">
        <el-pagination
          @current-change="toPage"
          background
          :page-size="8"
          :page-count="data.totalPage"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import util from '@/util/util';
  export default {
    name: "djgbpk",
    data(){
      return{
        searchs:'',
        isModel:false,
        loading:true,
        pageSize:7,
        page:1,
        data:[],
        name:'',
        num:'',
        spec:'',
        imageUrl: '',
        lsItem:[],
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      let data = {
        page:1,
        pageSize:me.pageSize,
        state:1,
      }
      httpUser.getgoodscommlist(data).then(res => {
        me.data = res.data;
        me.loading = false;
        console.log(res);
      })
    },
    methods:{
      jjtg(item){//拒绝通过
        me.$confirm('是否拒绝该申请?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          me.$Loading.start();
          let data = {
            id:item.id,
            state:3,
          }
          httpUser.addorupdategoodscomm(data).then(res => {
            switch (res.code) {
              case "0000":
                let data = {
                  page:me.page,
                  pageSize:me.pageSize,
                  state:1,
                }
                httpUser.getgoodscommlist(data).then(res => {
                  me.data = res.data;
                  me.$Loading.finish();
                  me.$message.success('已拒绝该申请');
                })
                break;
              case "1111":
                me.$Loading.error();
                me.$message.error('请稍后再试');
                break;
              case "1001":
                me.$Loading.error();
                me.$message.error('编号重复');
                break;
            }
          })
        }).catch(() => {
        });
      },
      tgsh(item){//通过审核
        me.$confirm('是否通过审核?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          me.$Loading.start();
          let data = {
            id:item.id,
            state:2,
          }
          httpUser.addorupdategoodscomm(data).then(res => {
            switch (res.code) {
              case "0000":
                let data = {
                  page:me.page,
                  pageSize:me.pageSize,
                  state:1,
                }
                httpUser.getgoodscommlist(data).then(res => {
                  me.data = res.data;
                  me.$Loading.finish();
                  me.$message.success('已通过审核');
                })
                break;
              case "1111":
                me.$Loading.error();
                me.$message.error('请稍后再试');
                break;
              case "1001":
                me.$Loading.error();
                me.$message.error('编号重复');
                break;
            }
          })
        }).catch(() => {
        });
      },
      xjsp(){//新建商品
        me.isModel = true;
      },
      seas(){
        me.$Loading.start();
        let data = {
          keyword:me.searchs,
          page:1,
          pageSize:me.pageSize,
          state:1,
        }
        httpUser.getgoodscommlist(data).then(res => {
          me.$Loading.finish();
          me.data = res.data;
        })
      },
      toPage(e){//分页
        me.loading = true;
        let data = {
          page:e,
          pageSize:me.pageSize,
          state:1,
        }
        if (me.searchs != '') {
          me.$set(data,'keyword',me.searchs);
        }
        me.page = e;
        httpUser.getgoodscommlist(data).then(res => {
          me.data = res.data;
          me.loading = false;
        })
      },
      cancel(){//添加框点击返回
        me.isModel = false;
      },
      back(){
        me.$router.push({path:'/djgbpk',query:{}});
      },
    }
  }
</script>

<style scoped>
  @import "djgsp.css";
</style>